/** V4 pipeline uses image_url; persisted Mongo rows use concept_art_image. */
export default function characterImageUrl(char) {
  if (!char || typeof char !== 'object') return '';
  return char.image_url || char.concept_art_image || '';
}
